module.exports = __webpack_public_path__ + "flyer_background_baby_layflat_color_100-f1d36efcef5d793f8bc961d9f7e4a195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_baby_layflat_color_100.jpg
// module id = 1600
// module chunks = 1